export function EmploymentEligibilitySvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/employment-eligibility.svg'"></ng-include>`
    }
}